import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { COLORS } from '../../styles';

export interface FormGroupProps {
  paths: string[];
  label?: React.ReactNode;
  className?: string;
  required?: boolean;
  multiline?: boolean;
  contentDisplayType?: 'inline' | 'block';
  children: React.ReactNode;
  onFocus?: () => void;
  onBlur?: () => void;
}

export function FormGroup(props: FormGroupProps): React.ReactElement {
  const {
    label,
    className,
    required,
    multiline = false,
    contentDisplayType = 'inline',
    children,
    onFocus,
    onBlur,
  } = props;
  // const node = useFieldContainer();
  // const error = useFieldErrors(node, paths);
  return (
    <FormGroupRow
      className={className}
      multiline={multiline}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      { label && (
        <FormGroupLabel hasMarginBottom={multiline}>
          { label }
          { required && <FormGroupRequired>*</FormGroupRequired> }
        </FormGroupLabel>
      ) }
      <FormGroupContent isInline={contentDisplayType === 'inline'}>
        { children }
      </FormGroupContent>
    </FormGroupRow>
  );
}

const FormGroupRow = styled.div<{ multiline: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  gap: 4px;
  padding: 8px 15px;
  ${({ multiline }) => multiline &&
    `
    display: block;
  `}
`;

const FormGroupLabel = styled.div<{ hasMarginBottom: boolean }>`
  display: flex;
  align-items: center;
  height: 32px;
  padding-right: 0 10px;
  font-size: 12px;
  font-weight: 500;
  color: ${COLORS.gray90};
  ${({ hasMarginBottom }) => hasMarginBottom && 'margin-bottom: 4px;'}
`;

const FormGroupRequired = styled.span`
  color: ${COLORS.red50};
`;

const FormGroupContent = styled.div<{ isInline?: boolean }>`
  display: grid;
  align-items: center;
  gap: 4px;
  ${({ isInline }) => isInline &&
    css`
      grid-template-columns: repeat(auto-fit, minmax(calc(50% - 2px), auto));
    `}
  > * {
    width: 100%;
  }
`;
